var styleDataHash = "d592c7eb";
const injectCss = (() => {
  var css = `._7S-kt,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.IMxfl{align-items:center;background-color:var(--wds-list-item-select-fill,var(--wsr-color-D80,#fff));color:var(--wds-color-text-standard-primary,var(--wsr-color-D10,#000624));cursor:pointer;display:flex;min-height:36px;padding-block:var(--ricos-internal-list-item-select-padding-block,6px);padding-inline:var(--ricos-internal-list-item-select-padding-inline,18px);--wds-color-text-standard-secondary:var(
    --wds-list-item-select-subtitle,var(--wsr-color-D40,#868aa5)
  )}.IMxfl:hover{background-color:var(--wds-list-item-select-fill-hover,var(--wsr-color-B50,#e7f0ff))}.IMxfl.WFjTm,.IMxfl:active{background-color:var(--wds-list-item-select-active-fill,var(--wsr-color-B10,#116dff));--wds-color-text-standard-primary:var(
    --wds-list-item-select-active-title,var(--wsr-color-D80,#fff)
  );--wds-color-text-standard-secondary:var(
    --wds-list-item-select-active-subtitle,var(--wsr-color-D80,#fff)
  )}.IMxfl.WFjTm:hover{background-color:var(--wds-list-item-select-active-fill-hover,var(--wsr-color-B20,#5999ff))}.IMxfl.gpDAF{background-color:var(--wds-list-item-select-fill,var(--wsr-color-D80,#fff));color:var(--wds-list-item-select-title-disabled,var(--wsr-color-D10-30,rgba(0,6,36,.3)));cursor:auto;pointer-events:none}.IMxfl:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important;outline-offset:-2px}.IMxfl.S4ARC{--wds-font-size-body-medium:16px}.IMxfl.Lf3B-{min-height:54px}.LYQ-d{column-gap:6px;display:grid;flex:1;grid-template-areas:"prefix title suffix";grid-template-columns:max-content 1fr max-content;grid-template-rows:auto auto}.Lf3B-{grid-template-areas:"prefix title suffix" "prefix subtitle suffix"}._928xA{align-items:center;align-self:center;display:flex;flex-shrink:0;grid-area:prefix}.LcpMw{align-self:center;grid-area:title}.LcpMw,.cRK9k{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cRK9k{grid-area:subtitle}.mMTEp{align-items:center;align-self:center;display:flex;flex-shrink:0;grid-area:suffix}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var list_item_select_default = {
  "fontElementMap": "_7S-kt",
  "root": "IMxfl",
  "selected": "WFjTm",
  "disabled": "gpDAF",
  "mobile": "S4ARC",
  "withSubtitle": "Lf3B-",
  "content": "LYQ-d",
  "prefix": "_928xA",
  "title": "LcpMw",
  "subtitle": "cRK9k",
  "suffix": "mMTEp"
};
export {
  list_item_select_default as default,
  injectCss
};
//# sourceMappingURL=list-item-select-scss.js.map
